import styled from 'styled-components';

export const StyledHeader = styled.nav`
  display: flex;
  justify-content: center;
  font-size: 100px;
  text-align:center;
  h1{
    width: 300px;
    
  }
  p{
    width: 125px;
    margin:auto 0;
  }
  svg{
    vertical-align: middle;
  }
  svg:hover{
    color: #323232;
  }
`;